SupportDealSummaryView = require('./deal_summary_view')

class SupportV2DealSummaryView extends SupportDealSummaryView

  toDealHash: ->
    dealHash = SupportDealSummaryView::toDealHash.call(this)
    dealHash.purchasedAt = @orderPresenter.getpurchasedAt()
    dealHash.qty = @orderPresenter.getOrderQuantity()
    dealHash.isV2 = true
    dealHash

module.exports = SupportV2DealSummaryView
